import { render, staticRenderFns } from "./CompanyUpload.vue?vue&type=template&id=5183a176&scoped=true"
import script from "./CompanyUpload.vue?vue&type=script&lang=js"
export * from "./CompanyUpload.vue?vue&type=script&lang=js"
import style0 from "./CompanyUpload.vue?vue&type=style&index=0&id=5183a176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183a176",
  null
  
)

export default component.exports